export const environment = {
    production: true,
    configuratorUrl: 'https://confibuild.com/configurator/',
    configuratorInterfaceOrigin: 'https://confibuild.com/configurator/',
    apiUrl: 'https://admin.snoei.prod.recognize.hosting/api',
    googleAnalyticsID: 'GTM-559JM2Z8',
    screenshotMode: '',
};
